<template>
    <section>
        <vue-snotify></vue-snotify>
        <div class="row">
            <div class="col-md-3 col-sm-12 cus-sidebar">
                <Sidebar />
            </div>
            <div v-if="isLoading" class="loader">
                <div class="wave-container">
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                </div>
                <p>Loading...</p>
            </div>  
            <div v-if="!isLoading" class="col-md-9 col-sm-12 right-colm">
                <div class="right-content content-record">
                    <div class="bg-white rsvp-page">
                        <br>
                        <h4 class="df-font d-inline-block">*Names in <span class="text-yellow">GOLD</span> are
                            attending</h4>
                        <h4 class="df-font d-inline-block right-text" style="margin-left: 55px;">*Names in <span
                                style="color: #eb633b;">RED</span> are not attending
                        </h4>
                        <hr>
                        <div class="text-danger text-center" style="display: none;">
                            <h5>{{ err.condition }}</h5>
                            <h5>{{ err.selectedUsers }}</h5>
                        </div>
                        <div>
                            <b-alert :show="errStatusCode" dismissible>
                                {{ statusErr }}
                            </b-alert>
                        </div>
                        <hr v-show="err.condition != '' || err.selectedUsers != ''" />
                        <div class="table-responsive">

                            <table cellpadding="0" cellspacing="0" class="table table-border rsvp-table new-rsvp-table">
                                <thead>
                                    <tr>
                                        <th>RSVP</th>
                                        <th>Attendees</th>
                                        <th>Seminar Name</th>
                                        <th>Seminar Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(seminar, index) in comingSeminars" :key="index">
                                        <td>
                                            <ul class="rsvp-list">
                                                <li>
                                                    <div class="checkbox-new radio-new radio">
                                                        <input type="radio"
                                                            :class="`float-left isregister_${seminar.ModuleNumber}`"
                                                            :name="`isregister_${seminar.ModuleNumber}`" id="register"
                                                            @click="rsvpCondition('register', seminar.ModuleName)"
                                                            :checked="reset">
                                                        <label for="radio-new"
                                                            class="float-left font_size_14">Register</label>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="checkbox-new radio-new radio">
                                                        <input type="radio"
                                                            :class="`float-left isregister_${seminar.ModuleNumber}`"
                                                            id="cancel" :name="`isregister_${seminar.ModuleNumber}`"
                                                            @click="rsvpCondition('cancel', seminar.ModuleName)"
                                                            :checked="reset">
                                                        <label for="radio-new"
                                                            class="float-left font_size_14">Cancel</label>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="checkbox-new radio-new radio">
                                                        <input type="radio"
                                                            :class="`float-left isregister_${seminar.ModuleNumber}`"
                                                            id="not_attending" :name="`isregister_${seminar.ModuleNumber}`"
                                                            @click="rsvpCondition('notAttending', seminar.ModuleName)"
                                                            :checked="reset">
                                                        <label for="radio-new" class="float-left font_size_14">Not
                                                            Attending</label>
                                                    </div>
                                                </li>
                                                <li><button class="blue-btn"
                                                        @click="resetModule(seminar.ModuleName)">Clear</button></li>
                                                <li><button class="yellow-btn"
                                                        @click="submitAttendees(seminar.ModuleName, seminar.ModuleNumber)">Save</button>
                                                </li>
                                            </ul>
                                        </td>
                                        <td>
                                            <ul class="rsvp-list" style="text-align: left;">
                                                <li v-for="(user, i) in usersData" :key="i">
                                                    <div
                                                        :class="`checkbox-new radio-new ${isAttending(seminar.isattending, seminar.attendees, user.UserID)}`">
                                                        <input type="checkbox" class="float-left attendees_4"
                                                            :name="`attendees${seminar.ModuleNumber}`"
                                                            @click="rsvpUser($event, seminar.ModuleName)"
                                                            :value="user.UserID" :checked="reset">
                                                        <label for="radio-new" class="float-left font_size_14">{{
                                                            user.FirstName }}
                                                            {{ user.LastName }} ({{ user.Status }})</label>
                                                    </div>
                                                </li>
                                            </ul>
                                        </td>
                                        <td class="content-colm content-colm-card">
                                            <div class="card-body">
                                                <div class="product-img">
                                                    <img class="img-responsive"
                                                    :src="`${$server_url}images/Modules/${seminar.ModuleSmallImage}`">
                                                </div>

                                                <p class="card-text">Module {{ seminar.ModuleNumber }}</p>
                                                <router-link
                                                    :to="{ name: 'single_module', params: { id: seminar.ModuleNumber } }" class="card_btn">{{
                                                        seminar.ModuleName }}</router-link>
                                            </div>
                                        </td>
                                        <td>{{ dateFormat(seminar.ModuleStartDate) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Vue from 'vue';
import Sidebar from './components/Sidebar.vue';
import userAPI from '../userApi';
import moment from 'moment'


export default {
    name: "userRSVP",
    data() {
        return {
            isLoading: false,
            err: {
                selectedUsers: '',
                condition: ''
            },
            comingSeminars: {},
            practiceID: "",
            formData: {},
            usersData: {},
            reset: '',
            validate: {
                formData: {}
            },
            statusErr: '',
            errStatusCode: false
        }
    },
    methods: {
        resetModule(moduleName) {
            this.reset = false;
            this.formData[moduleName] = {
                selectedUsers: [],
                condition: ''
            };
        },
        submitAttendees(moduleName, id) {
            let error = false;
            if (this.formData[moduleName] != undefined) {
                if (this.formData[moduleName].selectedUsers.length <= 0) {
                    this.err.selectedUsers = 'Please select a user of Module No ' + id + " " + moduleName;
                    error = true;
                }
                if (this.formData[moduleName].condition == '') {
                    this.err.condition = 'Please select a condition of Module No ' + id + " " + moduleName;
                    error = true;
                }
            } else {
                this.err.condition = 'Please select a field of Module No ' + id + " " + moduleName;
                error = true;
            }

            this.errStatusCode = false;
            if (error == false) {
                this.formData[moduleName].id = id;
                this.formData[moduleName].PracticeID = this.practiceID;
                userAPI.userRegisterForSeminar(this.formData[moduleName], res => {
                    this.$showNotification({ message: 'Operation Success' }, "success");
                    this.formData[moduleName] = {
                        selectedUsers: [],
                        condition: ''
                    };
                    this.getComingSeminars();
                }, err => {
                    if (err.response.status == 410) {
                        this.errStatusCode = true
                        this.statusErr = err.response.data.message
                    }
                })
            }
        },
        rsvpUser(event, moduleName) {
            this.reset = ''
            this.createModuleObj(moduleName);
            const checkboxValue = event.target.value;
            console.log(checkboxValue);
            if (event.target.checked) {
                this.formData[moduleName].selectedUsers.push(checkboxValue);
            } else {
                const index = this.formData[moduleName].selectedUsers.indexOf(checkboxValue);
                if (index > -1) {
                    this.formData[moduleName].selectedUsers.splice(index, 1);
                }
            }
        },

        createModuleObj(moduleName) {
            if (!this.formData[moduleName]) {
                this.formData[moduleName] = {
                    selectedUsers: [],
                    condition: ''
                };
            }
        },
        dateFormat(date) {
            return moment(date).format('MMMM, DD Y')
        },
        rsvpCondition(val, mod) {
            this.reset = ''
            this.createModuleObj(mod)
            this.formData[mod].condition = val;
        },
        getUsersByPractice() {
            userAPI.getUsersByPractice({ practiceID: this.practiceID }, res => {
                this.usersData = res.data.data;
            }, err => {
                console.log(err);
            });
        },
        getComingSeminars() {
            this.isLoading = true;
            userAPI.getComingSeminars({ practiceID: this.practiceID }, res => {
                this.comingSeminars = res.data.data;
                this.isLoading = false;


            }, err => {
                console.log(err);
                this.isLoading = false;

            })
        },
        isAttending(isattending, attendees, id) {
            // Split the attendingList string into an array of IDs
            if (isattending == null) {
                isattending = '';
            }

            if (attendees == null) {
                attendees = '';
            }

            const isattendingArr = isattending.split(',');
            const attendeesArr = attendees.split(',');
            if (isattendingArr.includes(id.toString()) == false && attendeesArr.includes(id.toString())) {
                return "text-yellow font-weight-bold";
            } else if (isattendingArr.includes(id.toString()) && attendeesArr.includes(id.toString())) {
                return "text-attending font-weight-bold";
            }
            return '';
        }
    },
    mounted() {
        if (localStorage.getItem('userDetails') != null) {
            this.practiceID = JSON.parse(localStorage.getItem('userDetails'))['PracticeID']
        } else {
            this.$router.push({ name: 'user_login' });
        }
        this.getComingSeminars();
        this.getUsersByPractice()
    },
    components: {
        Sidebar
    }
}
</script>